// Resolve from the same document that the workspace actually displays.
export function resolveSophieReport({ writeSourcesEnabled, writeDocument, patientId, historyItems = [], isPopupReport, selectedReport, sectionSummary, latestConsultationReport }) {
  if (writeSourcesEnabled) {
    if (!writeDocument?.id || writeDocument.scopePatientId !== patientId) return null;
    return historyItems.find(item => item.id === writeDocument.id) || writeDocument;
  }
  if (isPopupReport) return selectedReport?.id ? selectedReport : null;
  return sectionSummary?.id ? { id: sectionSummary.id, title: latestConsultationReport?.id === sectionSummary.id ? latestConsultationReport.title : 'Report' } : null;
}

export function sophieReportLabel(report, hasSelectedTranscript) {
  return report?.id ? `Using: ${report.title?.trim() || 'Report'}`
    : hasSelectedTranscript ? 'Selected transcript — generate a report to ask Sophie'
      : 'Open a report to ask about client records';
}

export function sophieRequestReportId(options, legacyId, answerSource) {
  if (answerSource !== 'current_report') return null;
  // Explicit null means no report is open in Write. Never reuse an old Live report.
  return Object.prototype.hasOwnProperty.call(options, 'reportContext') ? options.reportContext?.id || null : legacyId || null;
}

export async function saveSophieWriteReport(data, options, supabase, setHistoryItems) {
  const report = options.reportContext;
  if (!report?.id || String(report.id) !== String(data.report_id)) {
    throw new Error('The report in this response does not match the report used for this question.');
  }
  const { data: saved, error } = await supabase.from('generatedreports')
    .update({ content: data.report_content, updated_at: new Date().toISOString() }).eq('id', report.id).select('id');
  if (error) throw error;
  if (!saved?.length) throw new Error('The report could not be saved. It may have been deleted or access may have changed.');
  // Only update existing entries; a deleted or newly opened report stays untouched.
  setHistoryItems(items => items.map(item => item.id === report.id
    ? { ...item, originalData: { ...item.originalData, content: data.report_content } } : item));
  options.onReportUpdated?.(report.id, data.report_content);
}

// Source selection narrows the request; the server independently authorizes it.
export function sophieSourceSelection(items, patientId) {
  if (!items?.length) return undefined;
  if (items.length > 20) throw new Error('Select up to 20 sources for Sophie.');
  return items.map(item => {
    if (item.sourceError || item.unavailable) throw new Error('A selected source is unavailable.');
    if (item.type === 'Attachment') {
      if (typeof item.path !== 'string' || !item.path.startsWith(`${patientId}/`)) throw new Error('A selected file is unavailable.');
      return { kind: 'attachment', path: item.path };
    }
    if (item.type === 'Consultation' || item.type === 'Document') {
      if (!item.id) throw new Error('A selected source is unavailable.');
      return { kind: item.type === 'Consultation' ? 'consultation' : 'report', id: item.id };
    }
    throw new Error('This source cannot be used for questions.');
  });
}
